import i18n from '@/i18n';

/**
 * 전역 어디서나 사용 가능한 번역 헬퍼
 * 화면 리렌더링 필요 없는 유틸, 서비스 레이어, 콘솔 로그용으로 사용
 *
 * @param {string} key - 번역 키
 * @param {object} options - i18n 옵션 (선택)
 * @returns {string} - 번역된 문자열
 */

export const t = (key, options) => {
  return i18n.t(key, options);
};
